// extracted by mini-css-extract-plugin
export var box = "_3o-0";
export var check = "_3o-1";
export var checkboxButton = "_3o-6";
export var checkboxGroup = "_3o-5";
export var disabled = "_3o-7";
export var ghost = "_3o-9";
export var input = "_3o-2";
export var label = "_3o-4";
export var normal = "_3o-8";
export var uncheck = "_3o-3";